import React from "react";
import styled from "styled-components";

// context
import { useIosInputFocusLightBox } from "../useIosInputFocusLightBox";

// components
import CloseIcon from "core/ReusableIcons/Close";
import { UnstyledButton } from "core/Button/styles.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";
const CloseModalButtonStyled = styled(UnstyledButton)`
    position: absolute;
    top: ${convertPxToRem(24)};
    right: ${convertPxToRem(24)};

    width: ${convertPxToRem(50)};
    height: ${convertPxToRem(50)};

    border-radius: 50%;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: ${({ $isDarkMode }) =>
        $isDarkMode ? colors.primary.snow : colors.secondary.orca};

    svg {
        vertical-align: middle;
        path {
            fill: ${({ $isDarkMode }) =>
                $isDarkMode ? colors.secondary.orca : colors.primary.snow};
        }
    }
`;

// component
export const CloseModalButton = () => {
    const { setIsOpen, isOpen, isDarkMode } = useIosInputFocusLightBox();

    const onClick = () => {
        setIsOpen(false);
    };

    if (!isOpen) return null;

    return (
        <CloseModalButtonStyled onClick={onClick} $isDarkMode={isDarkMode}>
            <CloseIcon size={{ width: "24", height: "24" }} />
        </CloseModalButtonStyled>
    );
};

export default CloseModalButton;
